module.exports = __webpack_public_path__ + "img/24ne.f07fca5b.svg";